var React = require('react');

function BrandingDownloadButtonbg (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"45","height":"12","x":"52","y":"190","fill":"current","fillRule":"evenodd","rx":".965"}));
}

BrandingDownloadButtonbg.defaultProps = {"width":"413","height":"303","viewBox":"0 0 413 303"};

module.exports = BrandingDownloadButtonbg;

BrandingDownloadButtonbg.default = BrandingDownloadButtonbg;
